import createClient from '@bowtie-web/common/lib/client';

const client = createClient({
  context: {
    acceptLanguage: async () => {
      return localStorage.getItem('locale') || 'zh-hk';
    },
  },
});

export default client;
